import PropTypes from 'prop-types';
import { useRef } from 'react';
import { IconButton, Tooltip } from '@mui/material';

const RichTextColorButton = ({ title, icon, onApply, disabled = false }) => {
  const inputRef = useRef(null);

  return (
    <>
      <Tooltip title={title}>
        <IconButton
          size="small"
          onClick={() => {
            if (disabled) return;
            inputRef.current?.click();
          }}
          disabled={disabled}
        >
          {icon}
        </IconButton>
      </Tooltip>
      <input
        ref={inputRef}
        type="color"
        onChange={(event) => {
          const color = event.target.value;
          if (!color) return;
          onApply?.(color);
          // allow selecting the same color consecutively
          event.target.value = '';
        }}
        style={{ position: 'absolute', opacity: 0, width: 0, height: 0, pointerEvents: 'none' }}
        tabIndex={-1}
      />
    </>
  );
};

RichTextColorButton.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  onApply: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default RichTextColorButton;
